<template>
    <app-data-table
        :fields="fields"
        :items="data.data"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >

        <template slot="actions" slot-scope="{ item }">
            <b-button variant="primary" @click="addMenu(item)"><i class="fa fa-plus"></i></b-button>
        </template>

    </app-data-table>
    
</template>
<script>
    export default {
        data(){
            return {
                fields: [
                    {
                        key: 'name',
                        label: 'Nombre',
                        filter: true,
                        orderBy: 'menu_options.name'
                    },
                    {
                        key: 'menu.name',
                        label: 'Menú',
                        filter: true,
                        orderBy: 'menus.name'
                    },
                    {
                        key: 'slug',
                        label: 'Slug',
                        filter: true
                    },
                    {
                        key: 'description',
                        label: 'Descripción',
                        filter: true,
                        orderBy: 'menu_options.description'
                    },
                    {
                        key: 'order',
                        label: 'Orden',
                        filter: true,
                        orderBy: 'menu_options.order'
                    },
                    {
                        key: 'to',
                        label: 'Nombre de la página',
                        filter: true
                    },
                    {
                        key: 'actions',
                        label: 'Acciones'
                    }
                ]
            }
        },
        props: {
            data: {
                required: true
            },
            onChangePage: {
                type: Function,
                required: true
            }
        },
        methods: {
            addMenu(data){
                this.$emit('add-menu', data);
            },
            onSort(ctx) {
                this.$emit('sort', ctx);
            },
        }
    }
</script>